import BotOverrideDisplay from "features/bots/BotDrawer/BotOverrideDisplay";
import {
  BaseBotData,
  LanguageNameSpaces,
  OverrideFieldType,
} from "@shared/types";
import { USING_CHANNEL_SETTING } from "@shared/features/bots/constants";
import React from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface TrailingStopDisplayProps {
  botData?: BaseBotData;
  displayData:
    | string
    | { type: string; percent: string | undefined; trigger: string }
    | undefined;
  isChannelConfiguration?: boolean;
}

const TrailingStopDisplay = ({
  displayData,
  botData,
  isChannelConfiguration,
}: TrailingStopDisplayProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);

  return (
    <>
      {typeof displayData === "string" ? (
        displayData
      ) : (
        <>
          <div>{displayData?.type}</div>
          {displayData?.percent && <div>{displayData.percent}</div>}
          <div>{displayData?.trigger}</div>
        </>
      )}
      {!isChannelConfiguration && botData && (
        <BotOverrideDisplay
          botData={botData}
          overrideType={OverrideFieldType.TRAILING_STOP}
          isChannelValue={displayData === t(USING_CHANNEL_SETTING)}
        />
      )}
    </>
  );
};

export default TrailingStopDisplay;
